import { mic } from 'icons/mic.js';
import { micActive } from '../assets/micActive';
import { CSS_COLORS } from '../consts/consts';
import { hasClass } from '../helpers/helpers';
import { ENGT_CHAT } from './bot.model';
import { sendMsg } from './speech';

let SpeechSDK;

function getSpeechConfig(sdkConfigType) {
	const speechConfig = sdkConfigType.fromSubscription(
		ENGT_CHAT.get('config.azureVoiceIntegrationKey'),
		ENGT_CHAT.get('config.azureVoiceIntegrationRegion')
	);
	speechConfig.speechRecognitionLanguage = 'en-IN';
	return speechConfig;
}

function getAudioConfig() {
	return SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
}

export const voiceBotInit = () => {
	let recorder;
	const voiceBtn = document.getElementById('engtVoiceInputBtn');

	voiceBtn.addEventListener('click', handleVoiceBtnClick);

	(() => {
		if (window.SpeechSDK) {
			SpeechSDK = window.SpeechSDK;
		}
	})();

	function onRecognized(sender, recognitionEventArgs) {
		const { result } = recognitionEventArgs;
		sendMsg(result.text, false);
	}

	function onCanceled(sender, cancellationEventArgs) {
		window.console.log(cancellationEventArgs);
	}

	function handleAudioInput(recognizer) {
		recognizer.recognized = onRecognized;
		recognizer.canceled = onCanceled;
	}

	function stopVoiceRecognition() {
		recorder.stopContinuousRecognitionAsync(
			() => {
				recorder.close();
				recorder = undefined;
			},
			(err) => {
				window.console.log(err);
				recorder.close();
				recorder = undefined;
			}
		);
	}

	function doContinuousRecognition() {
		const audioConfig = getAudioConfig();
		const speechConfig = getSpeechConfig(SpeechSDK.SpeechConfig);
		if (!speechConfig) {
			return;
		}

		recorder = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
		handleAudioInput(recorder);

		recorder.startContinuousRecognitionAsync();
	}

	function handleVoiceBtnClick() {
		const replyInputArea = document.querySelector('.engt-reply-area');
		const voiceInput = document.querySelector('#engt-non-input-mode');
		const engtVoiceWrapper = document.getElementById('engtVoiceWrapper');
		const engtVoiceInputBtn = document.getElementById('engtVoiceInputBtn');
		if (hasClass(replyInputArea, 'engt-hidden')) {
			stopVoiceRecognition();
			voiceInput.style.display = 'none';
			replyInputArea.classList.remove('engt-hidden');
			engtVoiceWrapper.classList.remove('engtVoiceWrapper');
			engtVoiceInputBtn.innerHTML = micActive();
		} else {
			doContinuousRecognition();
			replyInputArea.classList.add('engt-hidden');
			engtVoiceWrapper.classList.add('engtVoiceWrapper');
			voiceInput.style.display = 'block';
			engtVoiceInputBtn.innerHTML = mic(CSS_COLORS.THEME_COLOR);
		}
	}
};

export const playVoiceFromAzure = (data) => {
	const speechConfig = getSpeechConfig(SpeechSDK.SpeechConfig);
	let synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig);

	synthesizer.speakTextAsync(
		data,
		(result) => {
			startSpeakTextAsyncButton.disabled = false;
			window.console.log(result);
			synthesizer.close();
			synthesizer = undefined;
		},
		(err) => {
			window.console.log(err);
			synthesizer.close();
			synthesizer = undefined;
		}
	);
};
